module.exports = __webpack_public_path__ + "static/header-background-new-6c9e14172b6922f78e3132539c8eca45.svg";